export const data = [
    {
      name: '1',
      uv: 300,
      pv: 0,
      amt: "Jan",
    },
    {
      name: '2',
      uv: 300,
      pv: 0,
      amt: "Feb",
    },
    {
      name: '3',
      uv: 200,
      pv: 0,
      amt: "Mar",
    },
    {
      name: '4',
      uv: 278,
      pv: 200,
      amt: "Apr",
    },
    {
      name: '5',
      uv: 189,
      pv: 100,
      amt: "May",
    },
    {
      name: '6',
      uv: 239,
      pv: 200,
      amt: "June",
    },
    {
      name: '7',
      uv: 349,
      pv: 200,
      amt: "July",
    },
    {
      name: '8',
      uv: 349,
      pv: 0,
      amt: "August",
    },
    {
      name: '9',
      uv: 349,
      pv: 430,
      amt: "Sept",
    },
    {
      name: '10',
      uv: 349,
      pv: 430,
      amt: "Oct",
    },
    {
      name: '11',
      uv: 349,
      pv: 430,
      amt: "Nov",
    },
    {
      name: '12',
      uv: 349,
      pv: 430,
      amt: "Dec",
    },
  ]